'use client'
import React from 'react'
import PlutoMain from './PlutoMain'

function PlutoHome() {
    return (
        <PlutoMain />
    )
}

export default PlutoHome
